import { useParams, Link } from 'react-router-dom'
import { ArrowLeft, Construction } from 'lucide-react'

export default function WorkshopRoom() {
  const { workshopId } = useParams()

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-4xl mx-auto">
        <Link
          to="/workshops"
          className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6"
        >
          <ArrowLeft className="w-5 h-5" />
          Volver a Talleres
        </Link>

        <div className="bg-white rounded-2xl shadow-sm p-12 text-center">
          <Construction className="w-16 h-16 mx-auto mb-4 text-yellow-500" />
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Sala del Taller
          </h1>
          <p className="text-gray-600 mb-4">
            Esta página está en construcción.
          </p>
          <p className="text-sm text-gray-500">
            Workshop ID: {workshopId}
          </p>
        </div>
      </div>
    </div>
  )
}
